module.exports = __webpack_public_path__ + "static/img/pro_bg_en.fb1020c3.png";